// dexie.ts
import { AbsenceRequest, dexieAbsenceRequest } from "@/entities/absenceRequest/absenceRequest"
import Dexie, { Table } from "dexie"
import { dexieAttendanceEvent } from "../entities/attendanceEvent/attendanceEventMeta"
import { AttendanceEvent } from "@/entities/attendanceEvent/AttendanceEventType"
import { dexieUser, User } from "../entities/user/user"
import { Todo } from "../types/todo"
import { SchoolYear, dexieSchoolYear } from "@/entities/schoolYear/schoolYear"
import { GlobalSettings, dexieGlobalSettings } from "@/entities/globalSettings/globalSettings"
import { middleware } from "./dexie-encrypt"

export class AppDB extends Dexie {
   todos!: Table<Todo>
   users!: Table<User>
   attendance_events!: Table<AttendanceEvent>
   absence_requests!: Table<AbsenceRequest>
   school_years!: Table<SchoolYear>
   global_settings!: Table<GlobalSettings>

   constructor() {
      super("tela_database_v11")
      this.version(1).stores({
         collection_last_updated_at: "id, last_updated_at",
         todos: "id, text, completed, created_at, updated_at",
         users: dexieUser,
         attendance_events: dexieAttendanceEvent,
         absence_requests: dexieAbsenceRequest,
         school_years: dexieSchoolYear,
         global_settings: dexieGlobalSettings,
      })
   }
}

export const dexie = new AppDB()

middleware(dexie)
